export var AREA_WIDTH = 900;
export var AREA_HEIGHT = 600;
export var CELL_SIZE = 100;
export var CELL_GAP = 3;
export var CARTRIDGE_SIZE = 30;
export var TOOLBAR_HEIGHT = 100;
export var CASTLE_WIDTH = 100;
export var SELECT_BOX_SIZE = 80;
